import React, { useMemo, useState } from "react";
import styles from "../../assets/styles/ExchangeTransaction/ExchangeTransaction.module.scss";
import {
  AppPage,
  BusinessInsightComponent as BIC,
  PageLoader,
  MimaButton,
  MimaNewFilter,
  MimaTable,
} from "../../components";
import moment from "moment";
import { amountFormatter } from "../../utils/utils";
import { downloadXlsx2 } from "../../utils/download";
import constant from "../../utils/constant";

const ExchangeTransactions = ({
  loading,
  filterHandler,
  exchangeTransactions,
  exchangeAnalysis,
  isLoading,
  data,
  isFetching,
  limit,
  onLimitChange,
  currentPage,
  setCurrentPage,
  setSearchQuery,
  setFilterQuery,
  setFromCurrency,
}) => {
  const [showFilter, setShowFilter] = useState(false);
  const [curr, setCurr] = useState("NGN");

  const exchangeAnalysisPerCurr = useMemo(() => {
    return exchangeAnalysis.filter((x) => {
      return x._id === curr;
    });
  }, [exchangeAnalysis, curr]);

  const PerCurr = [
    {
      key: "NGN",
      value: "NGN",
    },
    {
      key: "USD",
      value: "USD",
    },
    {
      key: "GBP",
      value: "GBP",
    },
    {
      key: "EUR",
      value: "EUR",
    },
  ];

  const filterByData = [{ value: "Date", key: "createdAt" }];

  const printData = data?.data?.histories.map((item) => ({
    Date: `${moment(item.createdAt).format("DD/MM/YYYY HH:mm a")}` || "",
    "Business Name": `${item.business?.tradingName}` || "",
    Amount: `${amountFormatter(item.fromCurrency).format(item.amount)}` || "",
    "Exchanged To": `${item.toCurrency}` || "",
    "Exchange Rate": `${item.ngnRate}` || "",
    "Amount Received":
      `${amountFormatter(item.toCurrency).format(item.value)}` || "",
  }));

  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.histories || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const creationDate = cell.row.original?.createdAt;
        return <span>{moment(creationDate).format("DD/MM/YYYY HH:mm a")}</span>;
      },
    },
    {
      Header: "Business Name",
      accessor: "tradingName",
      Cell: ({ cell }) => {
        const businessName = cell.row.original.business.tradingName;
        return <span>{businessName}</span>;
      },
    },
    {
      Header: "Amount",
      accessor: "amount",
      Cell: ({ cell }) => {
        const amount = cell.value;
        const currencyCode = cell.row.original.fromCurrency;
        const formattedAmount = amountFormatter(currencyCode).format(amount);
        return <span>{formattedAmount}</span>;
      },
    },
    {
      Header: "Exchanged To",
      accessor: "toCurrency",
      Cell: ({ cell }) => {
        const exchangedTo = cell.row.original?.toCurrency;
        return <span>{exchangedTo}</span>;
      },
    },
    {
      Header: "Exchange Rate",
      accessor: "ngnRate",
      Cell: ({ cell }) => {
        const exchngeRate = cell.row.original?.ngnRate;
        return <span>{exchngeRate}</span>;
      },
    },
    {
      Header: "Amount Received",
      accessor: "value",
      Cell: ({ cell }) => {
        const amount = cell.value;
        const currencyCode = cell.row.original.currencyCode;
        const formattedAmount = amountFormatter(currencyCode).format(amount);
        return <span>{formattedAmount}</span>;
      },
    },
  ];

  return (
    <AppPage pageTitle="Exchange Transactions">
      {loading ? (
        <PageLoader title="while we set things up for you" />
      ) : (
        <>
          <div className={styles.main_nav}>
            {PerCurr.map((item, i) => (
              <div
                key={i}
                className={
                  curr === item.key
                    ? styles.main_nav_item_active
                    : styles.main_nav_item
                }
                onClick={() => {
                  setCurr(item.key);
                  setFromCurrency(item.key);
                }}
              >
                {item.key} Transactions
              </div>
            ))}
          </div>
          <div className={styles.upper__metrics}>
            {exchangeAnalysisPerCurr.map((item, i) => (
              <>
                <BIC
                  info="Total Amount of Exchange Transactions"
                  title="Total Amount of Exchange Transactions"
                  amount={amountFormatter(item._id).format(item.amount)}
                  styleClass={styles.upper__metrics_totalAmount}
                />
                <BIC
                  info="Total Number of Exchange Transactions"
                  title="Total Number of Exchange Transactions"
                  amount={item.count}
                  styleClass={styles.upper__metrics_totalCount}
                />
              </>
            ))}
          </div>
          <div className={styles.filterSection}>
            <div>
              <MimaButton
                title={showFilter ? "Close Filter" : "Filter"}
                onClick={() => setShowFilter(!showFilter)}
                mt={2}
              />
            </div>

            <MimaButton
              title={`Download ${curr} Transaction Report`}
              onClick={() => {
                downloadXlsx2(printData);
              }}
              mt={2}
            />
          </div>
          <MimaNewFilter
            showFilter={showFilter}
            setShowFilter={setShowFilter}
            filterByData={filterByData}
            filterHandler={filterHandler}
          />
          <MimaTable
            tableData={tableData}
            tableColumns={tableColumns}
            searchPlaceholder="Search Exchange Transaction"
            searchVariant="wide"
            totalItems={data?.data?.totalCounts}
            onLimitChange={onLimitChange}
            isLoading={isLoading}
            isFetching={isFetching}
            limit={limit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setSearchQuery={setSearchQuery}
          />
        </>
      )}
    </AppPage>
  );
};
export default ExchangeTransactions;
